export const APARTMENT_TYPES = {
  'жилое':        0,
  'апартаменты':  1,
  'коммерческое': 2,
  'паркинг':      3,
};

export const DEVICE_TYPES = {
  'холодная вода':              0,
  'горячая вода':               1,
  'отопление':                  2,
  'ээ1':                        3,
  'ээ2':                        4,
  'ээ3':                        5,
  'газ':                        6,
  'отопление (распределитель)': 21,
  'отопление (шифрованный)':    22,
};

export const DEVICE_STATES = {
  'работает':                          1,
  'установлен':                        2,
  'сломан':                            3,
  'выведен из эксплуатации и заменен': 4,
  'истек срок эксплуатации':           5,
  'проверен':                          6,
  'отключен':                          7,
};

// export const DEVICE_RESTRICT_SEND_VALUES_REASONS = {
//   SETTINGS: 'Получаем автоматически или снимаем со счетчиков сами',
//   BROKEN:   'Прибор сломан, обратитесь в управляющую организацию',
// };
